import { t as __vitePreload } from "@theme/theme";
import { t as gsapWithCSS } from "@theme/gsap";
//#region frontend/lib/gsap-utils.js
var ST;
function refreshScrollTrigger() {
	ST?.refresh();
}
async function ensureScrollTrigger() {
	if (ST) return ST;
	const { ScrollTrigger } = await __vitePreload(async () => {
		const { ScrollTrigger } = await import("@theme/ScrollTrigger");
		return { ScrollTrigger };
	}, [], import.meta.url);
	gsapWithCSS.registerPlugin(ScrollTrigger);
	ST = ScrollTrigger;
	return ST;
}
var Split;
async function ensureSplitText() {
	if (Split) return Split;
	const { SplitText } = await __vitePreload(async () => {
		const { SplitText } = await import("@theme/SplitText");
		return { SplitText };
	}, [], import.meta.url);
	gsapWithCSS.registerPlugin(SplitText);
	Split = SplitText;
	return Split;
}
//#endregion
export { ensureSplitText as n, refreshScrollTrigger as r, ensureScrollTrigger as t };
